<template>
   <div class="step-item">
      <img class="step-item__image" :src="image" />
      <div class="step-item__step-index">{{ $t('landing.howItWorks.step')}} {{index}}</div>
      <div class="step-item__title h2bmedium">{{title}}</div>
      <div class="step-item__content">
         <slot></slot>
      </div>
   </div>
</template>

<script>
export default {
   props: ['image', 'index', 'title']
}
</script>

<style lang="scss">
.step-item {
  display: block;
  text-align: center;

  .step-item__image {
    height: 125px;
    width: auto;
    margin: 32px 32px 16px 32px;
  }

  .step-item__step-index {
    color: #97cd81;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.43px;
  }

  .step-item__title {
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/StepItem.vue